<template>
  <transition name="bounce">
    <b-container class="py-5 custom-container container">
      <b-card class="mt-5">
        <div class="mx-auto success-container">
          <b-card-title>
            <h2 class="font-weight-bold">Thank you for uploading your file.</h2>
          </b-card-title>

          <b-card-sub-title class="my-4">
            <h6 class="gray--1">
              View your
              <router-link
                :to="{
                  name: 'file.view-page',
                  params: { id: this.$route.params.id }
                }"
                >file</router-link
              >
              here. To share, simply click “share” under options and follow the
              prompts.
            </h6>
          </b-card-sub-title>
          <b-button
            variant="outline-secondary font-weight-bold"
            @click="goToHome()"
            >Go back to home page</b-button
          >
        </div>
      </b-card>
    </b-container>
  </transition>
</template>
<script>
export default {
  methods: {
    goToHome() {
      this.$router.replace({ name: 'home.welcome-page' })
    }
  }
}
</script>
<style lang="scss" scoped>
.success-container {
  text-align: center;
  padding: 3rem;
  width: 50%;

  @media (max-width: 767px) {
    width: 100% !important;
    padding: 2rem;
  }
}
</style>
